import { axiosServices } from "./axiosServices";

export const purchaseInvoiceServices = { getPurchaseInvoiceListing, getPIProductList };

function getPurchaseInvoiceListing(param) {
    return axiosServices.getAxios(`/v1/common/purchase-invoices${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}

function getPIProductList(piId, param) {
    return axiosServices.getAxios(`/v1/common/purchase-invoices/${piId}/products${param}`).then((res) => {
        // console.log(res);
        return res;
    });
}